import { render, staticRenderFns } from "./AgendaConfigList.vue?vue&type=template&id=0339ddf8&"
import script from "./AgendaConfigList.vue?vue&type=script&lang=js&"
export * from "./AgendaConfigList.vue?vue&type=script&lang=js&"
import style0 from "./AgendaConfigList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports